import { render, staticRenderFns } from "./MultiPaginationGridsTransfer.vue?vue&type=template&id=1a7fb5d0&scoped=true"
import script from "./MultiPaginationGridsTransfer.vue?vue&type=script&lang=js"
export * from "./MultiPaginationGridsTransfer.vue?vue&type=script&lang=js"
import style0 from "./MultiPaginationGridsTransfer.vue?vue&type=style&index=0&id=1a7fb5d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7fb5d0",
  null
  
)

export default component.exports